import script from "./Feeds.vue?vue&type=script&setup=true&lang=ts"
export * from "./Feeds.vue?vue&type=script&setup=true&lang=ts"

import "./Feeds.vue?vue&type=style&index=0&id=4d0223f0&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d0223f0"]])

export default __exports__